<template>
  <div id="setMenu" >
    <div class="page-box" :style="{backgroundImage: `url(${imgBg})` }">
      <com-header />
      <div class="page-box-search-scroll" v-infinite-scroll="load" infinite-scroll-distance="800" infinite-scroll-delay="500">
        <div class="set-menu-list">
          <div class="set-menu-list-item-item" v-for="item in imgList">
            <el-image
              :src="item.img"
              :preview-src-list="getHandleImg(imgList)">
            </el-image>
          </div>
        </div>
      </div>
    </div>
    <el-backtop target=".page-box-search-scroll"></el-backtop>
  </div>

</template>

<script>
export default {
  name: "setMenu",
  data(){
    return {
      navDrawer:false,
      imgList:[],
      imgBg:''
    }
  },
  mounted() {
    this.getImgList()
    this.getImgBg()
  },
  methods: {
    getImgBg() {
      this.$get('/pc/shop/bgimg', {id: 'combo'}).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    getHandleImg(data) {
      if (data.length > 0) {
        let arr = data.map((item) => {
          return item = item.img
        })
        return arr
      }
      return []
    },

    getImgList() {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass:'el-loading-com'
      });
     this.$get('/pc/shop/combo', {}).then((res) => {
       console.log('ddddddres',res)
        loading.close();
        this.imgList = [...this.imgList,...res.data]
      }).catch((error) => {
        loading.close();
      })
    },

  }
}
</script>

<style scoped lang="less">

.page-box {
  height: 100vh;
  background-size: cover;
}
.set-menu-list{
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
}
.set-menu-list-item-item{
  width:calc(25vw - 57px);
  //height: 22.18vw;
  margin:  0 20px 20px 0;
  border-radius: 4px;
  .el-image {
    width:calc(25vw - 57px);
    //height: 22.18vw;
    border-radius: 4px;
  }
}
.set-menu-list-item-item:nth-child(4n){
  margin-right: 0;
}
.set-menu-list-item-item img{
  width: 22.07vw;
  height: 22.18vw;
  border-radius: 6px 6px 0px 0px;
}
.set-menu-list-item-item .menu-title{
  padding-left: 39px;
  line-height: 100px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  border-radius: 0px 0px 6px 6px;

}
.set-menu-list-item-item:hover{
  transform: scale(1.02);
  transition: all 0.3s;
}
.set-menu-list-item-item:hover .menu-title{
  background: #E7B35E;
  color:#ffffff;
}

</style>



// WEBPACK FOOTER //
// src/views/setMenu.vue